import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function phoneValidator(): ValidatorFn {
  const phonePattern = /^\(\d{3}\) \d{3}-\d{4}$/; // (123) 456-7890
  return (control: AbstractControl): ValidationErrors | null => {
    const phoneValid = phonePattern.test(control.value);
    return phoneValid ? null : { phone: 'Phone is not valid' };
  };
}
